export default __webpack_public_path__ + "static/media/AgroIcon.ccc13775.svg";